module.exports = __webpack_public_path__ + "static/media/LOVES_TO_BE_BRUSHED.f15c0570.svg";